<template>
  <b-col cols="12" class="d-flex align-items-stretch flex-fill mt-3 mb-2">
    <b-card class="flex-fill">
      <b-col cols="12">
        <b-row  cols="12" class="mb-1">
          <b-col><p class="text-uppercase font-weight-bold text-danger  deviceWarningTitle">{{ $t('Device warnings component') }}</p>
          </b-col>
        </b-row>
        <router-link :to="{ name: 'DevicesContainer', query: {dgfe_perc_free:20}}">
          <b-row cols="12" class="mt-2 dangerText text-black">
            <div class="bg-danger warningicon d-flex justify-content-center align-items-center">
              <img src="/img/icons/sd_card.svg" class="" alt="">
            </div>
            <div class="d-flex justify-content-center align-items-center ml-20">
              <b-spinner class="align-middle mx-2" v-if="isLoading"></b-spinner>
              <span v-else class="font-weight-bold mx-3">
                {{dgfeWarning}}
              </span>
              <span> {{ $t('Warning memory exhaustion') }} </span>
            </div>
          </b-row>
        </router-link>
<!--        <router-link :to="{ name: '/', params: {}}">-->
<!--          <b-row cols="12" class="mt-2 dangerText text-black">-->
<!--            <div class="bg-danger warningicon d-flex justify-content-center align-items-center">-->
<!--              <img src="/img/icons/direct-send.svg" class="" alt="">-->
<!--            </div>-->
<!--            <div class="d-flex justify-content-center align-items-center ml-20">-->
<!--              <span class="font-weight-bold mx-3">12 </span>-->
<!--              <span> {{ $t('Warning failed submissions of fiscal receipts') }} </span>-->
<!--            </div>-->
<!--          </b-row>-->
<!--        </router-link>-->
        <router-link :to="{ name: 'DevicesContainer', query: {last_verification_date_months:1}}">
          <b-row cols="12" class="mt-2 dangerText text-black">
            <div class="bg-danger warningicon d-flex justify-content-center align-items-center">
              <img src="/img/icons/shield-cross.svg" class="" alt="">
            </div>
            <div class="d-flex justify-content-center align-items-center ml-20">
              <b-spinner class="align-middle  mx-2" v-if="isLoading"></b-spinner>
              <span class="font-weight-bold mx-3" v-else>
                {{periodicVerification}}
              </span>
              <span> {{ $t('Warning verification is due to expire') }} </span>
            </div>
          </b-row>
        </router-link>
      </b-col>
    </b-card>
  </b-col>
</template>

<script>
import NothingToShow from "./NothingToShow.vue";

export default {
  name: "DeviceWarnings",
  components: {NothingToShow},
  props: {
    dgfeWarning: {
      type: 0,
    },
    periodicVerification: {
      type: 0,
    },
    isLoading: {
      type: Boolean,
    },
  },
  data:  () => ({

  })
}
</script>

<style scoped>
  .deviceWarningTitle {
    font-size: 20px
  }
  .dangerText {
    font-size: 16px
  }
  .warningicon {
    border-radius: 5px;

    width: 40px;
    height: 40px;
  }
</style>
